import { render, staticRenderFns } from "./CallHistoryFooter.vue?vue&type=template&id=3dbac476&"
import script from "./CallHistoryFooter.vue?vue&type=script&lang=js&"
export * from "./CallHistoryFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports